<template lang="html">

  <div class="rrss">
    <nav class="row-center">
      <a href="https://www.carretilla.info/" class="contenedor-logo pastilla" target="_blank">
        <img src="/static/img/pastilla-carretilla.svg" alt="Logo carretilla">
      </a>
      <a target="_blank" href="https://www.instagram.com/carretilla_oficial/"><i class="fa fa-instagram"></i></a>
      <a target="_blank" href="https://www.facebook.com/carretillacomoesnatural"><i class="fa fa-facebook-square"></i></a>
      <a target="_blank" href="https://twitter.com/ElCarretillero"><i class="fa-brands fa-x-twitter"></i></a>
      <a target="_blank" href="https://www.youtube.com/user/carretilla"><i class="fa fa-youtube"></i></a>
    </nav>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'rrss',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
.rrss {
  position: absolute;
  right: 20px;
  top: 30px;
  z-index: 5;
}
.rrss.navidad i{
  color: #967842;
}
.rrss i{
  color: #212c55;
  font-size: 20px;
}

.rrss a{
  padding: 0 7px;
  cursor: pointer;
}


@media screen and (max-width: 600px){
  .rrss{
    // max-width: 100%;
    // right: 0;
    // left: 0;
    // top: 88px;
    display: none;
  }
  .rrss i{
    font-size: 24px;
  }
  .rrss a{
    padding: 0 8px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/parts/rrss.vue